// extracted by mini-css-extract-plugin
export var label = "_cr-1";
export var reminder = "_cr-0";